export class ClassicStayPreferences {
  categories: {};

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/reservation/stay-preferences/classic-stay-preferences.model.ts